export default __webpack_public_path__ + "static/media/2.079e5701.jpg";